import { AppBar, Grid, Tab, Tabs } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Fragment, useContext } from 'react';
import { useFlags, useAllowedNavRoutes } from '../../../hooks';
import { ExternalLinkPortalCard, LinkPortalCard, Page, PageTitle } from '../../../components';
import { UserContext } from '../../../context';
import {
  salesLandingLinks,
  hasNavAccess,
  hasNavActiveFlags,
  filterNavLinksForAccess
} from '../../../helpers';
import { SalesContext } from '../../../context/sales';
import { SalesDashboard } from '../dashboard';

export const SalesLanding = () => {
  const classes = useStyles();
  const featureFlags = useFlags();
  const userContext = useContext(UserContext);
  const { user } = userContext;
  const { availableLinks } = useAllowedNavRoutes(featureFlags, user);

  const { selectedSalesTab, setSelectedSalesTab } = useContext(SalesContext);

  const displayLinks = () => {
    if (featureFlags?.authorizeUserNavigationAccess) {
      return filterNavLinksForAccess(salesLandingLinks, userContext, featureFlags, availableLinks);
    }
    return salesLandingLinks;
  };

  const navigableLinks = displayLinks()
    .find(link => link?.name === selectedSalesTab)
    ?.links?.filter(link =>
      featureFlags?.authorizeUserNavigationAccess ? true : hasNavAccess(link.roles, userContext)
    )
    // check to make sure the the FF are active
    .filter(item => !!hasNavActiveFlags(item, featureFlags));

  return (
    <Page title="Sales" showSideBar={false} sideBarLinks={[]}>
      <PageTitle title="Sales" />
      <AppBar position="static" color="default" component="div" className={classes.tabBar}>
        <Tabs
          value={selectedSalesTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, value) => {
            setSelectedSalesTab(value);
          }}
        >
          {filterNavLinksForAccess(
            salesLandingLinks,
            userContext,
            featureFlags,
            availableLinks
          ).map((link, index) => {
            if (link.name === 'Purchasers') {
              return (
                <Tab
                  key={`${link.name}-tab`}
                  id={'Clients'}
                  value={'Clients'}
                  aria-controls={'Clients'}
                  label={'Purchasers'}
                />
              );
            }

            return (
              <Tab
                key={`${link.name}-tab`}
                id={link.name}
                value={link.name}
                aria-controls={link.name}
                label={link.name}
              />
            );
          })}
        </Tabs>
      </AppBar>

      {selectedSalesTab === 'Dashboard' ? (
        <SalesDashboard />
      ) : (
        <Grid spacing={2} container alignItems="center" className={classes.wrapper}>
          {navigableLinks?.map((link, i) => {
            const hasLegacyLink = link.legacyUrl && !link.url ? true : false;
            const hasLegacyLinkWithFFOff =
              link.featureFlag && link.legacyUrl && !featureFlags[link.featureFlag] ? true : false;

            return (
              <Fragment key={`${link.name}`}>
                <Grid xs={12} sm={6} md={4} item>
                  {hasLegacyLink || hasLegacyLinkWithFFOff ? (
                    <ExternalLinkPortalCard link={link} />
                  ) : (
                    <LinkPortalCard link={link} />
                  )}
                </Grid>
              </Fragment>
            );
          })}
        </Grid>
      )}
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    marginTop: '0',
    paddingBottom: '1rem'
  },
  tabBar: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  },
  link: {
    textDecoration: 'none'
  },
  cardRoot: {},
  content: {
    padding: 24,
    textAlign: 'center'
  }
}));
